export type SetServerTimeAction = {
  type: 'SET_SERVER_TIME_OFFSET';
  payload?: number;
};

export type SetServerRenderedAtAction = {
  type: 'SET_SERVER_RENDERED_AT';
  payload: string;
};

export type TimeAction = SetServerTimeAction | SetServerRenderedAtAction;

export const setServerTimeOffset = (payload?: number): SetServerTimeAction => ({
  type: 'SET_SERVER_TIME_OFFSET',
  payload
});

export const setServerRenderedAt = (
  payload: string
): SetServerRenderedAtAction => ({
  type: 'SET_SERVER_RENDERED_AT',
  payload
});
